import { createFileRoute } from '@tanstack/react-router';
import { AnalyticsOverview } from '../../components/analytics';

export const Route = createFileRoute('/team-insights/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AnalyticsOverview />;
}
